import { useEffect } from 'react'

type TProps = {
  shouldDisplayWarning: boolean
}

function useWarningUnsavedChangesOnAppClose({ shouldDisplayWarning }: TProps) {
  useEffect(() => {
    if (shouldDisplayWarning) {
      window.onbeforeunload = () => ''
    }

    return () => {
      window.onbeforeunload = null
    }
  }, [shouldDisplayWarning])
}

export default useWarningUnsavedChangesOnAppClose
